import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { BlogPostShell, POSTS } from "@/pages/Blog";

const POST = POSTS.find((p) => p.slug === "print-competitions-without-losing-prints");
const OG = "https://cameraclubscore.com/og/blog-generic.png";
const URL = "https://cameraclubscore.com/blog/print-competitions-without-losing-prints";

export default function PostPrint() {
  return (
    <>
      <Helmet>
        <title>{`${POST.title} — Camera Club Score`}</title>
        <meta name="description" content={POST.excerpt} />
        <link rel="canonical" href={URL} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={URL} />
        <meta property="og:title" content={POST.title} />
        <meta property="og:description" content={POST.excerpt} />
        <meta property="og:image" content={OG} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={OG} />
      </Helmet>
      <BlogPostShell post={POST}>
        <p className="lead">
          Print competitions are the soul of a good camera club. They also
          test everyone's admin skills more than any digital format ever
          will. Here's how to run them without ending up with three
          mystery prints and one angry member.
        </p>

        <h2>How do we organise print competitions?</h2>
        <p>
          Prints are physical objects. That means <strong>tracking</strong>
          {" "}is everything. Every print needs a label with the
          photographer's code and the image title on the back — not on
          the front where the judge can see it.
        </p>

        <h2>How do we record print titles?</h2>
        <p>
          Same as PDI: submit titles ahead of time by CSV, email, or web
          form. Never rely on reading the label under stage lights. If
          you don't have the titles typed up before the meeting, expect
          typos.
        </p>

        <h2>How do we keep track of mounted prints?</h2>
        <p>
          A physical sign-in sheet at the door — every member drops their
          prints and signs a line saying "I submitted N prints." At the
          end of the night, cross-check against that list before members
          leave. Five minutes' work, saves an evening of angry emails.
        </p>

        <h2>What's the best way to label prints?</h2>
        <p>
          Stick-on labels on the back of the mount. Fields:
        </p>
        <ul>
          <li>Photographer code (short, unique)</li>
          <li>Image title</li>
          <li>Competition name and date</li>
          <li>Which way is up (arrow — you'd be surprised)</li>
        </ul>
        <p>
          Camera Club Score can produce a printable sheet of these labels
          from the running order — the PDF export includes a "labels" mode
          designed to print onto standard Avery stock.
        </p>

        <h2>How do we avoid losing prints?</h2>
        <p>
          The rule that eliminates 90% of losses: <strong>never leave the
          judging table unattended</strong> until every print is back with
          its owner. Sounds obvious. Nobody actually does it.
        </p>

        <h2>How do we record returned prints?</h2>
        <p>
          At the end of the night, the sign-in sheet doubles as a
          sign-out sheet. Owner initials again next to their name. Any
          prints unclaimed go into a labelled box with the date — usually
          picked up next week.
        </p>

        <p>
          Once you've solved the physical tracking, the scoring workflow
          is identical to PDI. <Link to="/">Camera Club Score</Link>
          handles them the same way.
        </p>
      </BlogPostShell>
    </>
  );
}
